import { render } from "./DuplicateAddressPopup.vue?vue&type=template&id=2616f957"
import script from "./DuplicateAddressPopup.vue?vue&type=script&lang=js"
export * from "./DuplicateAddressPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__